<template>
  <v-row>
    <v-col cols="12">
      <v-fade-transition mode="out-in">
        <div v-if="loading.item">
          <v-card flat color="transparent" class="pb-6">
            <v-skeleton-loader type="heading"></v-skeleton-loader>
          </v-card>

          <v-card flat outlined color="transparent" class="pb-10">
            <v-card-text class="pa-0">
              <v-skeleton-loader type="article"></v-skeleton-loader>
            </v-card-text>
          </v-card>
        </div>

        <v-card v-else tile flat color="transparent">
          <v-card-title class="px-0 pt-0">
            <v-row align="center">
              <v-col>
                <div class="headline">Task list</div>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text class="pa-0">
            <v-card tile flat outlined>
              <v-card-title class="py-0 px-1" cols="9">
                <v-container fluid>
                  <v-row>
                    <v-col class="pb-0">
                      <span class="subtitle-1">Project: </span>
                      <router-link
                        class="subtitle-1"
                        :to="{
                          name: 'project',
                          params: { project_id: taskList.project.id }
                        }"
                      >
                        {{ taskList.project.name }}
                      </router-link>
                    </v-col>

                    <v-col align="right" class="pb-0" cols="3">
                      <div class="subtitle-1">{{ taskList.created_at }}</div>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pt-0" cols="9">
                      <div>{{ taskList.title }}</div>
                    </v-col>

                    <v-col align="right" class="pt-0" cols="3">
                      <form-modal
                        btnText="Edit"
                        modalTitle="Edit task list"
                        outlined
                        small
                        tile
                      >
                        <template #form="{ cancel }">
                          <task-list-create-edit-form
                            @cancel="cancel"
                            :projectId="taskList.project.id"
                            :taskList="taskList"
                          />
                        </template>
                      </form-modal>

                      <v-btn
                        class="ml-2"
                        outlined
                        small
                        tile
                        @click="confirmDelete(taskList.id)"
                        >Delete</v-btn
                      >
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col class="pt-0">
                      <v-divider></v-divider>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-title>

              <v-card-text>
                <v-row justify="center">
                  <v-col cols="8">
                    <discussions-card
                      :discussions="discussions"
                      :loading="discussionsLoading"
                    />
                  </v-col>
                </v-row>

                <v-row justify="center">
                  <v-col cols="8">
                    <discussion-create-edit-form
                      :discussableId="taskList.id"
                      storeModuleName="taskLists"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-text>
        </v-card>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DiscussionsCard from '@/components/discussions/DiscussionsCard'
import { alertConfirm } from '@/utilities/sweetalert'
import FormModal from '@/components/common/FormModal'
import TaskListCreateEditForm from '@/components/tasks/common/TaskListCreateEditForm'
import DiscussionCreateEditForm from '@/components/discussions/DiscussionCreateEditForm'

export default {
  name: 'TaskList',
  components: {
    DiscussionsCard,
    FormModal,
    TaskListCreateEditForm,
    DiscussionCreateEditForm
  },
  data: () => ({
    intervalId: null,
    discussionsLoading: true
  }),
  computed: {
    ...mapGetters('taskLists', ['loading', 'taskList', 'discussions']),
    taskListId() {
      return this.$route.params.task_list_id
    }
  },
  methods: {
    ...mapActions('taskLists', [
      'fetchTaskList',
      'fetchDiscussions',
      'deleteTaskList'
    ]),
    confirmDelete(id) {
      const projectId = this.taskList.project.id

      alertConfirm(
        {
          title: 'Are you sure you want to delete this task list?',
          text: 'All tasks under this will be deleted as well.'
        },
        () =>
          this.deleteTaskList(id).then(() => {
            this.$router.push({
              name: 'project',
              params: { project_id: projectId }
            })
          })
      )
    }
  },
  created() {
    this.fetchTaskList(this.taskListId)

    this.discussionsLoading = true // Loading only initiates once
    this.fetchDiscussions(this.taskListId).then(() => {
      this.discussionsLoading = false
    })

    this.intervalId = setInterval(() => {
      this.fetchDiscussions(this.taskListId)
    }, 5000) // TODO = change interval to realtime
  },
  beforeDestroy() {
    clearInterval(this.intervalId)
  }
}
</script>
